
import { defineComponent } from 'vue'
import { useSpaStaleBuildWatcher } from '@/composables/useSpaStaleBuildWatcher'
import CrmSpaStaleUpdateBanner from '@/components/Spa/CrmSpaStaleUpdateBanner.vue'

export default defineComponent({
  name: 'CrmSpaStaleUpdateRoot',
  components: { CrmSpaStaleUpdateBanner },
  setup() {
    const { stale, snooze } = useSpaStaleBuildWatcher()
    return { stale, snooze }
  },
})
